import { render, staticRenderFns } from "./casos.html?vue&type=template&id=2db3c46e&"
import script from "./casos.ts?vue&type=script&lang=ts&"
export * from "./casos.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports